import { render, staticRenderFns } from "./DetailPrestages.vue?vue&type=template&id=04fe5b31&"
import script from "./DetailPrestages.vue?vue&type=script&lang=js&"
export * from "./DetailPrestages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports